<template>
  <v-dialog v-model="dialog" max-width="700" dark scrollable>
    <v-card style="background-color: #1e1e1e">
      <v-card-title class="d-flex align-center">
        <v-icon left color="#58d388">mdi-account-group</v-icon>
        <span>Team-Anmeldungen</span>
        <v-spacer />
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <div class="mb-4 grey--text text-caption">
          Hier siehst du den Anmeldestatus deines Teams für: <strong class="white--text">{{ terminTitle }}</strong>
        </div>

        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Mitarbeiter suchen..."
          outlined
          dense
          hide-details
          class="mb-4"></v-text-field>

        <v-progress-linear v-if="loading" indeterminate color="#58d388" class="mb-4"></v-progress-linear>

        <div v-for="emp in filteredTeam" :key="emp.userId" class="emp-row d-flex align-center pa-3 rounded-lg mb-2">
          <div class="flex-grow-1">
            <div class="font-weight-bold">{{ emp.name }}</div>
            <div class="text-caption grey--text">
              {{ emp.email }} <span v-if="emp.percentage"> · {{ emp.percentage }}%</span>
            </div>
          </div>

          <v-chip v-if="emp.status !== 'not_registered'" small :color="statusColor(emp.status)" class="mr-3 font-weight-bold" text-color="white">
            {{ statusLabel(emp.status) }}
          </v-chip>

          <div class="actions">
            <v-btn
              v-if="emp.status === 'not_registered' || emp.status === 'cancelled'"
              small
              color="#58d388"
              class="black--text"
              :loading="busyIds.includes(emp.userId)"
              @click="enroll(emp)">
              Anmelden
            </v-btn>
            <v-btn v-else icon small color="red" :loading="busyIds.includes(emp.userId)" @click="unenroll(emp)">
              <v-icon small>mdi-account-remove</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"

export default {
  name: "TeamRegistrationDialog",
  data() {
    return {
      dialog: false,
      terminId: null,
      terminTitle: "",
      team: [],
      loading: false,
      search: "",
      busyIds: [],
    }
  },
  computed: {
    filteredTeam() {
      if (!this.search) return this.team
      const s = this.search.toLowerCase()
      return this.team.filter((e) => e.name.toLowerCase().includes(s))
    },
  },
  methods: {
    async open(termin) {
      this.terminId = termin._id
      this.terminTitle = termin.title
      this.dialog = true
      this.loadTeam()
    },
    async loadTeam() {
      this.loading = true
      try {
        this.team = await api.akademie.fetchTerminTeamStatus(this.terminId)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async enroll(emp) {
      this.busyIds.push(emp.userId)
      try {
        await api.akademie.adminAddRegistration(this.terminId, emp.userId)
        await this.loadTeam()
        this.$emit("refresh") // <--- Das hier triggert loadTermine() im Dashboard!
      } finally {
        this.busyIds = this.busyIds.filter((id) => id !== emp.userId)
      }
    },
    async unenroll(emp) {
      if (!confirm(`${emp.name} wirklich abmelden?`)) return
      this.busyIds.push(emp.userId)
      try {
        await api.akademie.adminCancelRegistration(this.terminId, emp.registrationId)
        await this.loadTeam()
        this.$emit("refresh") // <--- Auch beim Abmelden refreshen!
      } finally {
        this.busyIds = this.busyIds.filter((id) => id !== emp.userId)
      }
    },
    statusColor(s) {
      const colors = {
        registered: "green",
        waiting_list: "orange",
        attended: "blue",
        no_show: "red",
        cancelled: "grey",
      }
      return colors[s] || "grey"
    },
    statusLabel(s) {
      const labels = {
        registered: "Angemeldet",
        waiting_list: "Warteliste",
        attended: "Besucht",
        no_show: "Nicht da",
        cancelled: "Storniert",
      }
      return labels[s] || "Unbekannt"
    },
  },
}
</script>

<style scoped>
.emp-row {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
</style>
